export default "__VITE_ASSET__BMIGePQ7__"